<template>
    <div class="md-layout-item md-size-100">
        <div v-if="adjustmentDetails.isDriver" class="md-layout-item md-size-100">
            <form-group name="teamMemberUserIds" label="Team member" attribute="Team member">
                <md-input v-model="adjustmentDetails.teamMemberUserIds" type="hidden" />
                <vue-select
                    label="fullName"
                    :options="teamMembers"
                    v-model="adjustmentDetails.teamMemberUserIds"
                    :reduce="(r) => r.userId"
                    :multiple="true"
                    :disabled="adjustmentDetails.isEditing"
                    :append-to-body="true"
                    :close-on-select="false"
                ></vue-select>
            </form-group>
        </div>

        <div v-if="adjustmentDetails.isCustomer" class="md-layout-item md-size-100">
            <form-group name="customerIds" label="Customer" attribute="Customer">
                <md-input v-model="adjustmentDetails.customerIds" type="hidden" />
                <vue-select
                    label="value"
                    :options="customers"
                    v-model="adjustmentDetails.customerIds"
                    :reduce="(r) => Number(r.key)"
                    :multiple="true"
                    :disabled="adjustmentDetails.isEditing"
                    :append-to-body="true"
                    :close-on-select="false"
                ></vue-select>
            </form-group>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AdjustmentCreateNewComponent',
    props: {
        adjustmentDetails: {
            type: Object,
            default: () => {}
        },
        teamMembers: {
            type: Array,
            default: () => []
        },
        customers: {
            type: Array,
            default: () => []
        }
    }
};
</script>
<style lang="scss" scoped>
::v-deep .vs__selected {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-wrap: nowrap;
    color: white;
    background-color: #41b883;
}
</style>
